import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { Meta, provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { CacheInterceptor } from './common/helpers/CacheInterceptor';
import { ModalGuard } from './common/helpers/modalGuard';
import { BottomSheetService } from './common/services/bottomsheet.service';
import { CanonicalService } from './common/services/canonical.service';
import { DataService } from './common/services/data.service';
import { GlobalService } from './common/services/global.service';
import { MeasuresService } from './common/services/measures.service';
import { ModalService } from './common/services/modal.service';
import { PersistenceService } from './common/services/persistence.service';
import { PersistenceLocalStorageService } from './common/services/persistencelocalstorage.service';
import { RequestService } from './common/services/request.service';
import { SidebarSwipeService } from './common/services/sidebar-swipe.service';
import { WindowRef } from './common/services/window.service';
import { environment } from '../environments/environment';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { translateBrowserLoaderFactory } from './common/helpers/translate-browser.loader';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { registerLocaleData } from '@angular/common';
import de from '@angular/common/locales/de';
import en from '@angular/common/locales/en';
import es from '@angular/common/locales/es';
import esMx from '@angular/common/locales/es-MX';
import fr from '@angular/common/locales/fr';
import it from '@angular/common/locales/it';
import ja from '@angular/common/locales/ja';
import ko from '@angular/common/locales/ko';
import pl from '@angular/common/locales/pl';
import pt from '@angular/common/locales/pt';
import ru from '@angular/common/locales/ru';
import th from '@angular/common/locales/th';
import tr from '@angular/common/locales/tr';
import zhHant from '@angular/common/locales/zh-Hant';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

registerLocaleData(en, 'en_us');
registerLocaleData(es, 'es_es');
registerLocaleData(esMx, 'es_mx');
registerLocaleData(fr, 'fr_fr');
registerLocaleData(de, 'de_de');
registerLocaleData(pt, 'pt_br');
registerLocaleData(it, 'it_it');
registerLocaleData(ko, 'ko_kr');
registerLocaleData(th, 'th_th');
registerLocaleData(ja, 'ja_jp');
registerLocaleData(ru, 'ru_ru');
registerLocaleData(pl, 'pl_pl');
registerLocaleData(tr, 'tr_tr');
registerLocaleData(zhHant, 'zh_tw');
export function getImagesUrl() {
  return "https://cdn.runeterra.ar/";
}
 
export const appConfig: ApplicationConfig = {
  providers: [
    { provide: 'IMAGES_URL', useFactory: getImagesUrl },
    provideAuth(() => getAuth()),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideHttpClient(withFetch()),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: translateBrowserLoaderFactory,
        deps: [HttpClient],
      },
    }),
    provideClientHydration(),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    SsrCookieService,
    GlobalService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheInterceptor,
      multi: true
    },
    DataService,
    Meta,
    ModalGuard,
    {
      provide: PersistenceService,
      useClass: PersistenceLocalStorageService,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {
        closeOnNavigation: false,
        //enterAnimationDuration: '0ms',
        exitAnimationDuration: '0ms'
      }
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        appearance: 'fill',
        floatLabel: 'auto',
        subscriptSizing: 'fixed'
      } 
    },
    {
      provide: MAT_TABS_CONFIG, useValue: {
        animationDuration: '1ms'
      }
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'never' } },
    ModalService,
    MeasuresService,
    BottomSheetService,
    RequestService,
    SidebarSwipeService,
    WindowRef,
    CanonicalService,
    { provide: LOCALE_ID, useValue: 'en_us' }, importProvidersFrom(FormsModule), provideAnimationsAsync(), provideHttpClient()
    //, provideHttpClient(withInterceptorsFromDi())
  ]
};
